import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { Background, Topbar } from '@/components'
import { Promo, useStoreActions, useStoreState } from '@/stores'
import { Icons } from '@/assets'
import { cn } from '@/utils'
import moment from 'moment'

export const PromoDetail = () => {
  const { id } = useParams()
  const location = useLocation()

  const item: Promo = location?.state?.item

  const { detail } = useStoreState(state => state.promo)
  const { fetchDetail } = useStoreActions(action => action.promo)

  useEffect(() => {
    if (!item) fetchDetail(Number(id))
  }, [item, id, fetchDetail])

  const Image = ({ item }: { item: Promo }) => {
    const [error, setError] = useState<boolean>(false)

    if (error || !item?.photos?.[0])
      return (
        <div
          className="flex justify-center items-center aspect-square bg-[#f5f5f5] animate-fade"
        >
          <img
            className="h-10 opacity-20"
            src={Icons.image_break}
            alt="icon"
          />
        </div>
      )

    return (
      <div
        className="aspect-square bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${item?.photos?.[0]})` }}
      >
        <img
          className="hidden"
          src={item?.photos?.[0]}
          onError={() => setError(true)}
          alt="outlet"
        />
      </div>
    )
  }

  const data = detail || item

  return (
    <div>
      <Background />
      <div
        className={cn(
          "flex flex-col bg-white bg-opacity-30 min-h-screen",
          "min-h-dvh"
        )}
      >
        <div className="flex flex-1 flex-col">
          <Topbar />
          <div className="flex-1">
            <Image item={data} />
            <div className="p-5">
              <div className="font-outfit font-semi-bold text-xl text-black/70">
                {data?.name}
              </div>
              <div className="font-outfit font-regular text-sm text-black/70 mt-2">
                Outlet: <span className="font-semibold">{data?.store?.name}</span>
              </div>
              <div className="font-outfit font-regular text-sm text-black/70">
                Valid until: <span className="font-semibold">{moment(data?.period?.end).format('DD MMMM YYYY')}</span>
              </div>
              <div
                className="font-outfit font-regular text-sm text-black/70 mt-4"
                dangerouslySetInnerHTML={{ __html: data?.description || '' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
